import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal } from "semantic-ui-react";
import { selectTranslations } from "../../../config/i18n/slice";
import DataTable from "react-data-table-component";
import { ArrowLeft, ArrowRight, CloseIcon } from "../../../../Assets/Icons/svg";
import Pagination from "../../common/Pagination";

function CategoryBulkUploadResult({
  isOpen = false,
  setModalOpenState = () => {},
  categoryData = {},
  setCategoryUploadModal,
}) {
  const t = useSelector(selectTranslations);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#E9F2FF",
        paddingTop: "8px",
      },
    },
  };

  const getPaginatedData = (dataToPaginate) => {

    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataToPaginate.slice(startIndex, endIndex);
  };
  /**
   * Table Fields
   */
  const columns = [
    {
      name: t.categories.add,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: t.categories.status,
      selector: (row) => row.reason,
      sortable: true,
      cell: (row) =>
        row?.reason ? (
          <span className="text-dark-red">{t.categories.failed}</span>
        ) : (
          <span className="text-dark-green">{t.categories.success}</span>
        ),
    },
    {
      name: t.assets.message,
      selector: (row) => row?.reason,
      cell: (row) => (row?.reason ? row?.reason : "-"),
    },
  ];
  return (
    <Modal
      size="large"
      open={isOpen}
      onClose={() => setModalOpenState(false)}
      className="assets-modal category-modal"
    >
      <div className="header-container">
        <span className="assets-header">{t.categories.table.bulkCategory}</span>
        <div>
          <span
            className="c-pointer text-right"
            onClick={() => setModalOpenState(false)}
          >
            <CloseIcon />
          </span>
        </div>
      </div>

      <Modal.Content
        className="scroll-data"
 
      >
        <div className="mb-7">
          <span className="new-grey-btn ml-0 mr-0">
            {t.categories.table.importedCategory} &nbsp; &nbsp; &nbsp;
            {categoryData?.importedCategory
              ? categoryData?.importedCategory
              : 0}{" "}
          </span>

          <span className="new-grey-btn green ml-7 mr-7">
            {t.categories.table.validRows} &nbsp; &nbsp; &nbsp;
            {categoryData?.successCategory
              ? categoryData?.successCategory
              : 0}{" "}
          </span>
          <span className="new-grey-btn red ml-0 mr-0">
          {t.categories.table.inValidRows} &nbsp; &nbsp; &nbsp;
            {categoryData?.failedCategory
              ? categoryData?.failedCategory
              : 0}{" "}
          </span>
        </div>

        <div className="bulk-upload-table">
          <DataTable
            columns={columns}
            customStyles={customStyles}
            data={getPaginatedData(categoryData?.data || [])}
            noDataComponent={t.common.no_result_found}
            direction={selectedLanguage === "en" ? "ltr" : "rtl"}
          />
        </div>

        <div className="d-flex justify-content-end">
          <Pagination
            ofString={t.common.of}
            total={categoryData?.data?.length}
            prevItem={
              selectedLanguage === "en" ? <ArrowLeft /> : <ArrowRight />
            }
            nextItem={
              selectedLanguage === "en" ? <ArrowRight /> : <ArrowLeft />
            }
            page={currentPage}
            limit={pageSize}
            handleNext={() => {
              setCurrentPage(currentPage + 1);
            }}
            handlePrevious={() => {
              setCurrentPage(currentPage - 1);
            }}
            parts={true}
          />
        </div>

        <div
          className={`modal-button-container justify-content-center mt-4 ${
            selectedLanguage == "en" ? "mr-8" : "ml-10"
          }`}
        >
          <button
            onClick={() => {
              setCategoryUploadModal(true);
              setModalOpenState(false);
            }}
            className="modal-form-action-button light-blue"
          >
            {t.categories.table.reuploadFile}
          </button>
        </div>
      </Modal.Content>
    </Modal>
  );
}

export default CategoryBulkUploadResult;
